/* eslint-disable @angular-eslint/no-input-rename */

import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  MatPaginatorModule,
  MatPaginator,
  PageEvent,
} from '@angular/material/paginator';
import { IQueryParam } from 'modelos/src';

@Component({
  imports: [
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ],
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() saveName?: string;
  private name?: string;

  pageSize: number = 10;
  goTo: number = 1;
  totalPages: number = 0;
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @Input() disabled = false;
  @Input() hidePageSize = false;
  @Input() hideGoTo = false;
  /** Fija el tamaño de página e ignora el valor guardado en localStorage. */
  @Input() fixedPageSize?: number;
  @Input() pageSizeOptions: number[] = [];
  @Input() showFirstLastButtons = false;

  @Input() pageIndex = 0;
  @Input() length: number = 0;

  @Input() public query?: IQueryParam;
  @Output() public queryChange = new EventEmitter<IQueryParam>();

  constructor() {}

  private getSavedPageSize(): number | void {
    if (this.name) {
      const saved = localStorage.getItem(this.name);
      if (saved) {
        return +saved;
      }
    }
    return;
  }
  private savePageSize() {
    // Con tamaño fijo no persistimos (evita contaminar el saveName que
    // comparten otras vistas).
    if (this.fixedPageSize) return;
    if (this.name) {
      localStorage.setItem(this.name, this.pageSize.toString());
    }
  }

  public paginationChange(pageEvt: PageEvent) {
    this.length = pageEvt.length;
    this.pageIndex = pageEvt.pageIndex;
    this.pageSize = pageEvt.pageSize;
    this.savePageSize();
    this.updateGoto();
    this.emitQueryChange(pageEvt);
  }

  public goToChange() {
    // Clamp a [1, totalPages]
    let n = Math.floor(this.goTo);
    if (!n || n < 1) n = 1;
    if (this.totalPages && n > this.totalPages) n = this.totalPages;
    this.goTo = n;

    const pageIndex = n - 1;
    if (this.paginator) {
      this.paginator.pageIndex = pageIndex;
    }
    const event: PageEvent = {
      length: this.length,
      pageIndex,
      pageSize: this.pageSize,
    };
    this.paginator?.page.next(event);
    this.emitQueryChange(event);
  }

  private updateGoto() {
    this.goTo = (this.pageIndex || 0) + 1;
    this.totalPages = Math.max(1, Math.ceil(this.length / this.pageSize));
  }

  private async emitQueryChange(event: PageEvent): Promise<void> {
    this.query = this.query || {};
    this.query.page = event.pageIndex;
    this.query.limit = event.pageSize;
    this.queryChange.emit(this.query);
  }

  ngOnInit() {
    this.name = this.saveName ? `page-${this.saveName}` : undefined;
    this.pageSize =
      this.fixedPageSize || this.getSavedPageSize() || this.pageSize;
    this.updateGoto();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pageIndex) {
      this.pageIndex = changes.pageIndex.currentValue;
      // Sin esto el input "Ir a" sigue mostrando la página anterior cuando la
      // página se resetea desde afuera (ej: cambio de rango de fechas).
      this.updateGoto();
    }

    if (changes.length) {
      this.length = changes.length.currentValue;
      this.updateGoto();
    }
  }
}
